/* Ramen Kingdom — header behaviour.
   1. Nav fit: the desktop menu never wraps. If a language's labels do not fit
      beside the logo and the utilities, the header stacks the menu onto its
      own row (class rk-nav-stacked) instead of breaking mid-menu.
   2. Locale control: one disclosure for country + language; a change submits
      Shopify's localization form. */
(function () {
  'use strict';

  /* ---- 1. nav fit --------------------------------------------------------- */
  var header = document.querySelector('.m-header');
  var desktop = header && header.querySelector('.m-header__desktop.logo-left-menu-center');
  var center = desktop && desktop.querySelector('.m-header__center');
  var menu = center && center.querySelector('.m-menu');
  var columns = desktop ? desktop.querySelectorAll('.m-header__left, .m-header__center, .m-header__right') : [];

  /* a column's children spilling past its box on either side */
  function spills(col) {
    var box = col.getBoundingClientRect();
    for (var i = 0; i < col.children.length; i++) {
      var c = col.children[i].getBoundingClientRect();
      if (c.left < box.left - 1 || c.right > box.right + 1) return true;
    }
    return false;
  }

  function fit() {
    if (!menu) return;
    if (window.innerWidth < 1024) { header.classList.remove('rk-nav-stacked'); return; }
    header.classList.remove('rk-nav-stacked');
    /* measured with the menu on one row: anything spilling means it does not
       fit (scrollWidth is useless here — the hidden dropdown panels count) */
    var over = spills(menu);
    for (var i = 0; i < columns.length && !over; i++) over = spills(columns[i]);
    if (over) header.classList.add('rk-nav-stacked');
    header.classList.add('rk-nav-measured');
  }

  if (menu) {
    var raf;
    window.addEventListener('resize', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(fit);
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    fit();
  }

  /* ---- 2. locale control -------------------------------------------------- */
  var roots = document.querySelectorAll('[data-rk-locale]');
  if (!roots.length) return;

  var openRoot = null;

  function setOpen(root, open) {
    var trigger = root.querySelector('[data-rk-locale-trigger]');
    var panel = root.querySelector('.rk-locale__panel');
    if (!trigger || !panel) return;
    panel.hidden = !open;
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    root.classList.toggle('is-open', open);
    openRoot = open ? root : null;
  }

  Array.prototype.forEach.call(roots, function (root) {
    var trigger = root.querySelector('[data-rk-locale-trigger]');
    var form = root.querySelector('[data-rk-locale-form]');

    if (trigger) {
      trigger.addEventListener('click', function (e) {
        e.preventDefault();
        var willOpen = root.classList.contains('is-open') === false;
        if (openRoot && openRoot !== root) setOpen(openRoot, false);
        setOpen(root, willOpen);
      });
    }

    if (form) {
      form.addEventListener('change', function (e) {
        if (!e.target.matches('select')) return;
        root.classList.add('is-busy');
        form.submit();
      });
    }
  });

  document.addEventListener('click', function (e) {
    if (openRoot && !openRoot.contains(e.target)) setOpen(openRoot, false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openRoot) {
      var t = openRoot.querySelector('[data-rk-locale-trigger]');
      setOpen(openRoot, false);
      if (t) t.focus();
    }
  });
})();
